import React, { useState, useEffect } from 'react';
import adminService from '../../../../services/adminService';

const LookerReport = ({ source, title, topBanner }) => {
  const [iframeUrl, setIframeUrl] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchReportUrl = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await adminService.getAnalyticsDashboard(source);
        if (response.success && response.data?.iframe_url) {
          setIframeUrl(response.data.iframe_url);
        } else {
          setError('Failed to load report URL');
        }
      } catch (err) {
        console.error(`Error fetching Looker report for ${source}:`, err);
        setError('Error connecting to analytics service');
      } finally {
        setLoading(false);
      }
    };

    fetchReportUrl();
  }, [source]);

  return (
    <div className="p-6 bg-[#ecf0f5] min-h-screen">
      {topBanner ? <div className="mb-4 max-w-6xl">{topBanner}</div> : null}
      {/* Header */}
      <div className="mb-6">
        <h1 className="mb-4" style={{ 
          fontFamily: "'Bahnschrift Light', sans-serif", 
          color: "black", 
          fontSize: "30px",
          marginTop: "20px",
          marginBottom: "10px"
        }}>
          {title}
        </h1>
      </div>

      {/* Main Container */}
      <div className="bg-white rounded shadow-sm p-4 overflow-hidden" style={{ minHeight: 'calc(100vh - 200px)' }}>
        {loading ? (
          <div className="flex flex-col items-center justify-center h-[600px]">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-yellow-500 mb-4"></div>
            <p className="text-gray-500">Loading Report...</p>
          </div>
        ) : error ? (
          <div className="flex flex-col items-center justify-center h-[600px] text-red-500">
            <i className="fas fa-exclamation-triangle text-4xl mb-4"></i>
            <p>{error}</p>
            <button 
              onClick={() => window.location.reload()} 
              className="mt-4 px-4 py-2 bg-yellow-500 text-white rounded hover:bg-yellow-600 transition-colors"
            >
              Retry
            </button>
          </div>
        ) : (
          <>
            <iframe
              src={iframeUrl}
              title={title}
              width="100%"
              style={{
                border: '0',
                height: 'calc(100vh - 250px)',
                minHeight: '800px',
              }}
              allowFullScreen
              referrerPolicy="strict-origin-when-cross-origin"
              sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-forms"
            />
            <p className="text-xs text-gray-500 mt-2 px-1">
              If the report area is blank, open the report in Looker Studio → Embed → Enable embedding,
              and add this site origin (e.g. localhost:3000 or your admin domain) to allowed embed domains.
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default LookerReport;
